/**
 * @generated SignedSource<<15bc46ace877add5faba6e289315024a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AllUserSelectFragment$data = {
  readonly avatars: {
    readonly urlToSize20: string | null;
    readonly urlToSize28: string | null;
    readonly urlToSize32: string | null;
    readonly urlToSize40: string | null;
    readonly urlToSize56: string | null;
    readonly urlToSize64: string | null;
    readonly urlToSize80: string | null;
  } | null;
  readonly name: string | null;
  readonly rawId: number | null;
  readonly username: string | null;
  readonly " $fragmentType": "AllUserSelectFragment";
};
export type AllUserSelectFragment$key = {
  readonly " $data"?: AllUserSelectFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"AllUserSelectFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AllUserSelectFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "rawId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "UserAvatars",
      "kind": "LinkedField",
      "name": "avatars",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "urlToSize20",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "urlToSize28",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "urlToSize32",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "urlToSize40",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "urlToSize56",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "urlToSize64",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "urlToSize80",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "username",
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "505a7b901f4543b789540c03ae2627ff";

export default node;
